import React, { useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { useStoreValue, storeSet } from '../../../../store';
import ButtonFlat from '../../../../components/ButtonWrapper/components/ButtonFlat';
import ButtonFlatAccent from '../../../../components/ButtonWrapper/components/ButtonFlatAccent';
import CrownIcon from '../../../../icons/CrownIcon';

const formatBytes = (bytes) => {
    if (bytes === null || bytes === undefined) return '—';
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(0)} MB`;
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};

const formatPrice = (priceCents) =>
    priceCents === 0 ? 'Gratis' : `€${priceCents / 100}`;

const ProfileSubscription = () => {
    const userCounters = useStoreValue('userCounters');
    const userData = useStoreValue('userData');
    const plans = useStoreValue('plans');
    const plansLoading = useStoreValue('plansLoading');

    useEffect(() => {
        storeSet('fetchUserCounters');
        storeSet('fetchPlans');
    }, []);

    const isCurrentPlan = (plan, index) =>
        userData?.planId ? plan.id === userData.planId : index === 0;

    const currentPlan = (plans || []).find((p, i) => isCurrentPlan(p, i));
    const currentPlanName = currentPlan?.name || __('Piano', 'soundbetween');

    const handleSelectPlan = () => {
        // I pagamenti non sono ancora attivi: nessun checkout finto.
        window.alert(__('Il passaggio di piano non e ancora attivo: i pagamenti arriveranno a breve. Nel frattempo contattaci per cambiare piano.', 'soundbetween'));
    };

    return (
        <section className="workbenchProfile workbenchProfile--subscription">

            {/* Section 1: Current Plan */}
            <div className="subCurrentPlan">
                <div className="subCurrentPlan__headerWrapper">
                    <div className="subCurrentPlan__header">
                        <h3 className="workbenchProfile__sectionTitle">
                            {currentPlanName}
                        </h3>
                    </div>
                    <CrownIcon />
                </div>
                <dl className="subCurrentPlan__stats">
                    <div className="subCurrentPlan__stat">
                        <dt>{__('Progetti Attivi', 'soundbetween')}</dt>
                        <dd>{userCounters?.activeProjects ?? '—'} / {userCounters?.maxProjects ?? '-'}</dd>
                    </div>
                    <div className="subCurrentPlan__stat">
                        <dt>{__('Storage Usato', 'soundbetween')}</dt>
                        <dd>{formatBytes(userCounters?.usedStorageBytes)} / {userCounters?.maxStorage ?? '-'}</dd>
                    </div>
                    <div className="subCurrentPlan__stat">
                        <dt>{__('Collaboratori', 'soundbetween')}</dt>
                        <dd>{userCounters?.invitedCollaborators ?? '—'} / {userCounters?.maxCollaborators ?? '—'}</dd>
                    </div>
                </dl>
            </div>

            {/* Section 2: Available Plans (reali, dal backend) */}
            <div className="subPlans">
                <h3 className="workbenchProfile__sectionTitle">
                    {__('Piani Disponibili', 'soundbetween')}
                </h3>
                {plansLoading ? (
                    <p className="subPlans__loading">{__('Caricamento piani…', 'soundbetween')}</p>
                ) : (
                    <ul className="subPlans__grid">
                        {(plans || []).map((plan, index) => {
                            const isCurrent = isCurrentPlan(plan, index);
                            const price = formatPrice(plan.priceCents);
                            const showPeriod = plan.priceCents !== 0;
                            return (
                                <li
                                    key={plan.id}
                                    className={`planCard${isCurrent ? ' planCard--current' : ''}`}
                                >
                                    <div className="planCard__header">
                                        <CrownIcon />
                                        <span className="planCard__name">{plan.name}</span>
                                    </div>
                                    <div className="planCard__price">
                                        <span className="planCard__amount">{price}</span>
                                        {showPeriod && (
                                            <span className="planCard__period">/mese</span>
                                        )}
                                    </div>
                                    <ul className="planCard__features">
                                        {(plan.features || []).map((feature) => (
                                            <li key={feature} className="planCard__feature">{feature}</li>
                                        ))}
                                    </ul>
                                    {isCurrent
                                        ? <ButtonFlat size="md" type="button" disabled onClick={() => {}}>
                                            {__('Piano Attuale', 'soundbetween')}
                                        </ButtonFlat>
                                        : <ButtonFlatAccent size="md" type="button" onClick={handleSelectPlan}>
                                            {__('Seleziona', 'soundbetween')}
                                        </ButtonFlatAccent>}
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>

            {/* Section 3: Storico Pagamenti — nessun sistema di pagamento ancora attivo */}
            <div className="subPayments">
                <h3 className="workbenchProfile__sectionTitle">
                    {__('Storico Pagamenti', 'soundbetween')}
                </h3>
                <p className="subPayments__empty">
                    {__('Nessun pagamento registrato.', 'soundbetween')}
                </p>
            </div>

        </section>
    );
};

export default ProfileSubscription;
